import { Component, OnInit, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'form-control-validation-label',
  templateUrl: './form-control-validation-label.component.html',
  styleUrls: ['./form-control-validation-label.component.scss'],
})
export class FormControlValidationLabelComponent implements OnInit {

    @Input() control: NgControl;
    @Input() messages: any;

  constructor() { }

    ngOnInit() {
    }

    showError(errors) {
        if (!errors)
            return '';

        if (errors.required) {
            return 'Required';
        }
        else {
            if (errors['error'] && this.messages && this.messages[errors['error']])
                return this.messages[errors['error']];
            else
                return 'Invalid';
        }
    }
}
